/**
 * Utility functions for persisting and retrieving the last visited workspace ID
 * using localStorage. Handles localStorage errors gracefully.
 */

const STORAGE_KEY = "last_workspace_id";

/**
 * Retrieves the last workspace ID from localStorage.
 * @returns The workspace ID string, or null if not found or on error
 */
export function getLastWorkspaceId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    // Silently fail if localStorage is unavailable (e.g., private browsing, disabled)
    console.warn("Failed to read from localStorage:", error);
    return null;
  }
}

/**
 * Persists the workspace ID to localStorage.
 * @param id - The workspace ID to store
 */
export function setLastWorkspaceId(id: string): void {
  try {
    localStorage.setItem(STORAGE_KEY, id);
  } catch (error) {
    // Silently fail if localStorage is unavailable
    console.warn("Failed to write to localStorage:", error);
  }
}

/**
 * Removes the last workspace ID from localStorage.
 */
export function clearLastWorkspaceId(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // Silently fail if localStorage is unavailable
    console.warn("Failed to clear localStorage:", error);
  }
}
